module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/addd6b3a6dd680c6a39da59de1a039a9.png";